import React from 'react';
import { Link } from 'react-router-dom';
import './CompanyInfo.css';

const CompanyInfo = () => {
    return (
        <div className="company-info-container">
            <div className="company-info-content">
                <h2 className="company-info-title">Welcome to <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span></h2>
                <div className="company-info-text">
                    <p>
                        At <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span>, we are your trusted partner in digital transformation and business growth. 
                        With our comprehensive suite of services including AI development, digital marketing, 
                        and dedicated team solutions, we help businesses thrive in the digital age.
                    </p>
                    <p>
                        Our team of experts brings years of experience across multiple industries, 
                        delivering innovative solutions tailored to your unique business needs. 
                        From startups to established enterprises, we provide scalable solutions 
                        that drive success and foster growth.
                    </p>
                    <p>
                        With a commitment to excellence and a passion for innovation, 
                        we ensure that every project we undertake meets the highest standards 
                        of quality and delivers measurable results.
                    </p>
                </div>
                <Link to="/contact" className="hire-now-button">
                    Hire Now
                </Link>
            </div>
        </div>
    );
};

export default CompanyInfo;